import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App";
import "./index.css";
import { AuthProvider } from "./providers/AuthProvider";
import { AuthProvider as OIDCAuthProvider } from "react-oidc-context";
import * as Sentry from "@sentry/react";

const cognitoDomain = import.meta.env.VITE_COGNITO_HOSTED_UI_DOMAIN;
const userPoolId = import.meta.env.VITE_COGNITO_AUTHORITY?.split("/").pop();
const region = userPoolId?.split("_")[0];

const currentOrigin = window.location.origin;

const cognitoAuthConfig = {
  authority: import.meta.env.VITE_COGNITO_AUTHORITY,
  client_id: import.meta.env.VITE_COGNITO_CLIENT_ID,
  redirect_uri: `${currentOrigin}/auth/signin-callback`,
  post_logout_redirect_uri: `${currentOrigin}/auth/signout-callback`,
  response_type: "code",
  scope: "profile openid email",
  automaticSilentRenew: true,
  metadata: {
    issuer: import.meta.env.VITE_COGNITO_AUTHORITY,
    authorization_endpoint: `${cognitoDomain}/oauth2/authorize`,
    token_endpoint: `${cognitoDomain}/oauth2/token`,
    userinfo_endpoint: `${cognitoDomain}/oauth2/userInfo`,
    end_session_endpoint: `${cognitoDomain}/logout`,
    jwks_uri: `https://cognito-idp.${region}.amazonaws.com/${userPoolId}/.well-known/jwks.json`,
  },
  onSigninCallback: () => {
    window.history.replaceState({}, document.title, window.location.pathname);
  },
};

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  sendDefaultPii: true,
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter>
      <OIDCAuthProvider {...cognitoAuthConfig}>
        <AuthProvider>
          <App />
        </AuthProvider>
      </OIDCAuthProvider>
    </BrowserRouter>
  </React.StrictMode>,
);
